import loadable from "@loadable/component";
import React from "react";

const PLPGrid = process.env.NODE_ENV === "production" ? () => null : loadable(() => import("./PLPGrid"));

const DevNav: React.FC = process.env.NODE_ENV === "production" ? () => null : () => <PLPGrid />;

export default DevNav;
